module.exports = __webpack_public_path__ + "img/hr-rock-huge-14.4fd4ef4d.png";